export const customStyles = {
   doublelines: {
      display: 'flex',
      width: '150%',
      margin: '0 1%',
      minWidth: '200px',
   },
   inline: {
      display: 'inline-block',
      width: '150%',
      margin: '0',
      minWidth: '200px',
   },
};
  